

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { IFeaturesSection } from '../../data/model';

@Component({ components: {} })
export default class PcJumbo extends Vue {
    @Prop()
    private section!: IFeaturesSection;
}
